import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from 'react';
export const Spinner = (props) => {
    return props && props.loading ? <span style={{fontFamily: "'Open Sans', sans-serif"}}><FontAwesomeIcon icon="spinner" spin/> {props.children}</span> : null
}
